import { Component, Input } from '@angular/core'
import { Observable } from 'rxjs'
import { StaticLayerConfig } from '../../../state/viewer/viewer.state'
import { JobApiService } from '../../../shared/services/job-api.service'
import { Store } from '@ngrx/store'
import { closeJobSelectionDialog } from '../../../shared/utils/job-selection-dialog-utils'
import { selectSegmentationLayers } from '../../../state/viewer/viewer.selectors'
import { HttpErrorResponse } from '@angular/common/http'
import { ToasterService } from '../../../shared/services/toaster.service'
import { PipelineType } from '../../../shared/model/jobs'
import { environment } from '../../../../environments/environment'

@Component({
    selector: 'app-intensity-selection',
    templateUrl: './intensity-selection.component.html',
    styleUrls: ['./intensity-selection.component.scss'],
})
export class IntensitySelectionComponent {
    @Input()
    siblingDatasets: string[] | never[]
    segmentationLayers$: Observable<StaticLayerConfig[]>
    selectedTargetLayer: StaticLayerConfig | null
    submitted: boolean = false
    runBatchJob: boolean = false

    private readonly wikiUrl = environment.wikiUrl

    constructor(
        store: Store,
        private readonly jobApi: JobApiService,
        private readonly toaster: ToasterService
    ) {
        this.segmentationLayers$ = store.select(selectSegmentationLayers)
    }

    get canStart(): boolean {
        return !!this.selectedTargetLayer && !this.submitted
    }

    cancel(): void {
        closeJobSelectionDialog()
    }

    startJob(): void {
        if (!this.canStart) return
        this.submitted = true

        this.jobApi
            .startIntensityJob({
                type: PipelineType.MapIntensity,
                target: this.selectedTargetLayer!.name,
                mask: undefined,
                batch: this.runBatchJob,
            })
            .subscribe({
                next: () => closeJobSelectionDialog(),
                error: (err: HttpErrorResponse) => {
                    this.toaster.httpError(err, 'Error starting job')
                },
            })
    }

    selectTargetLayer(layer: StaticLayerConfig): void {
        this.selectedTargetLayer = layer
    }

    goToWiki(): void {
        window.open(`${this.wikiUrl}home/Working_with_jobs#h-3-intensity-map`, '_blank')
    }
}
